import styled from 'styled-components'

import { mq, sizes } from '../../theme'

export const Wrapper = styled.div`
  & > *:not(:first-child) {
    margin-top: 2rem;
  }
  @media ${mq(sizes.desktop)} {
    & > *:not(:first-child) {
      margin-top: 4.5rem;
    }
  }
`
export const Title = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;
  &::first-letter {
    text-transform: uppercase;
  }
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.titleH2_30}
    text-align: left;
  }
`
export const Content = styled.div`
  @media ${mq(sizes.desktop)} {
    &&:not(:first-child) {
      margin-top: 0.5rem;
    }
  }
`
